import Router from 'next/router';

export const switchLanguage = (locale?: string) => {
  Router.push({ pathname: Router.pathname, query: Router.query }, Router.asPath, {
    locale: locale ?? 'en',
  });
};
